import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import ToolsMenu from '@/components/tools/ToolsMenu';
import DropdownItem from '@/components/DropdownItem';
import { cloneCohortClause, deleteCohortClause, showRenameClause } from '../actions';

const CohortClauseTools = ({
  category,
  clauseUUID,
  code,
  dictionaryCode,
  duplicate,
  queryUUID,
  remove,
  rename,
}) => {
  const intl = useIntl();
  return (
    <ToolsMenu pointing={null}>
      <DropdownItem
        icon="edit"
        textId="actions.rename"
        onClick={() => rename(code, category, queryUUID, clauseUUID)}
      />
      <DropdownItem
        icon="clone"
        textId="actions.duplicate"
        onClick={() => duplicate(code, category, queryUUID, clauseUUID, dictionaryCode, intl)}
      />
      <DropdownItem
        className="delete-file"
        icon="trash alternate"
        textId="actions.delete"
        onClick={() => remove(code, category, queryUUID, clauseUUID, dictionaryCode, intl)}
      />
    </ToolsMenu>
  );
};

const mapDispatchToProps = {
  rename: showRenameClause,
  remove: deleteCohortClause,
  duplicate: cloneCohortClause,
};

export default connect(null, mapDispatchToProps)(CohortClauseTools);
